export default {
  Total: '今天',
  Yesterday: '昨天',
  Nearly7Day: '近7天',
  Export: '导出',
  ControlDirection: '控制方向',
}